import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { HOW_TRANSFERS_WORKS_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FeeFreeTransferBenefitsModal = (props) => {
    const {
        gotIt,
        feeFreeTransferTitle,
        feeFreeTransferBlock1Title,
        feeFreeTransferBlock1Text,
        feeFreeTransferBlock2Title,
        feeFreeTransferBlock2Text,
        feeFreeTransferBlock3Title,
        feeFreeTransferBlock3Text,
        feeFreeTransferNote,
    } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(HOW_TRANSFERS_WORKS_SCREEN_SHOWN);
    }, []);

    return (
        <ModalComponent hasBottomPanel onCloseIconClick={() => props.toggleModal(false)}>
            <HeaderPanel title={feeFreeTransferTitle} />
            <DocsList>
                <DocsListItem blackText title={feeFreeTransferBlock1Title}>
                    <Text variant="div">{feeFreeTransferBlock1Text}</Text>
                </DocsListItem>
                <DocsListItem blackText title={feeFreeTransferBlock2Title}>
                    <Text variant="div">{feeFreeTransferBlock2Text}</Text>
                </DocsListItem>
                <DocsListItem blackText title={feeFreeTransferBlock3Title}>
                    <Text variant="div">{feeFreeTransferBlock3Text}</Text>
                </DocsListItem>
            </DocsList>
            <Text variant="div" size="secondary" color="secondary">
                {feeFreeTransferNote}
            </Text>
            <FixedBottomPanel isRightAligned>
                <Button
                    type="button"
                    raised={true}
                    caption={gotIt}
                    onClick={() => {
                        props.toggleModal(false);
                    }}
                />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default connect(null, { toggleModal })(FeeFreeTransferBenefitsModal);
